import React, { ReactElement } from 'react';
import { Button } from 'src/domains/common/components/button/button';

interface NewBonusCreationButtonsPropsType {
    onClose: () => void;
    onSaveAsDraft: () => void;
    onPublish: () => void;
}
export const NewBonusCreationButtons = ({
    onClose,
    onSaveAsDraft,
    onPublish,
}: NewBonusCreationButtonsPropsType): ReactElement => (
    <>
        <Button
            variant='ghost'
            onClick={onClose}
            dataTest='bonus-creation-close-button'
        >
            Close
        </Button>

        <Button
            variant='secondary'
            onClick={onSaveAsDraft}
            dataTest='bonus-creation-save-as-draft-button'
        >
            Save as Draft
        </Button>

        <Button
            variant='primary'
            onClick={onPublish}
            dataTest='bonus-creation-publish-button'
        >
            Publish
        </Button>
    </>
);

interface DraftBonusCreationButtonsPropsType {
    onClose: () => void;
    onUpdate: () => void;
    onPublish: () => void;
}
export const DraftBonusCreationButtons = ({
    onClose,
    onUpdate,
    onPublish,
}: DraftBonusCreationButtonsPropsType): ReactElement => (
    <>
        <Button
            variant='ghost'
            onClick={onClose}
            dataTest='bonus-creation-close-button'
        >
            Close
        </Button>

        <Button
            variant='secondary'
            onClick={onUpdate}
            dataTest='bonus-creation-update-button'
        >
            Update
        </Button>

        <Button
            variant='primary'
            onClick={onPublish}
            dataTest='bonus-creation-publish-button'
        >
            Publish
        </Button>
    </>
);

interface PublishedBonusCreationButtonsPropsType {
    onClose: () => void;
    onUnpublish: () => void;
}
export const PublishedBonusCreationButtons = ({
    onClose,
    onUnpublish,
}: PublishedBonusCreationButtonsPropsType): ReactElement => (
    <>
        <Button
            variant='ghost'
            onClick={onClose}
            dataTest='bonus-creation-close-button'
        >
            Close
        </Button>
        <Button
            variant='destructive'
            onClick={onUnpublish}
            dataTest='bonus-creation-pause-button'
        >
            Unpublish
        </Button>
    </>
);
